<script setup>
import { ref, computed } from 'vue';
import { useStore } from 'vuex';
import { useI18n } from 'vue-i18n';
import ProjectFileList from './ProjectFileList.vue';
import ProjectCollapsibleBox from './ProjectCollapsibleBox.vue';
import ProjectDocumentRequests from './ProjectDocumentRequests.vue';
import ProjectStatusReports from './ProjectStatusReports.vue';
import ProjectNotes from './ProjectNotes.vue';

const props = defineProps({
  projectId: {
    type: [String, Number],
    required: true,
  },
});

const store = useStore();
const { t } = useI18n();

const fileCount = ref(0);
const requestCount = ref(0);
const reportCount = ref(0);

const noteCount = computed(
  () =>
    store.getters['projectNotes/getNotesByProject'](Number(props.projectId))
      .length
);
</script>

<template>
  <div class="grid grid-cols-1 gap-5 lg:grid-cols-3">
    <!-- Left: typed documents -->
    <div class="lg:col-span-2">
      <ProjectFileList :project-id="projectId" @count="fileCount = $event" />
    </div>

    <!-- Right: collapsible boxes -->
    <div class="flex flex-col gap-4">
      <ProjectCollapsibleBox
        :title="t('PROJECTS.DOCUMENTS.BOX_REQUESTS')"
        icon="i-lucide-file-check-2"
        :count="requestCount"
      >
        <ProjectDocumentRequests
          :project-id="projectId"
          @count="requestCount = $event"
        />
      </ProjectCollapsibleBox>

      <ProjectCollapsibleBox
        :title="t('PROJECTS.DOCUMENTS.BOX_STATUS_REPORTS')"
        icon="i-lucide-clipboard-list"
        :count="reportCount"
      >
        <ProjectStatusReports
          :project-id="projectId"
          embedded
          @count="reportCount = $event"
        />
      </ProjectCollapsibleBox>

      <ProjectCollapsibleBox
        :title="t('PROJECTS.DOCUMENTS.BOX_NOTES')"
        icon="i-lucide-sticky-note"
        :count="noteCount"
      >
        <ProjectNotes :project-id="projectId" />
      </ProjectCollapsibleBox>
    </div>
  </div>
</template>
